import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger, SheetClose } from "../ui/sheet";
import { LogoMark } from "./LogoMark";

const LINKS = [
  { to: "/services", label: "Services" },
  { to: "/speaking", label: "Speaking" },
  { to: "/about", label: "About" },
  { to: "/resources", label: "Resources" },
  { to: "/book", label: "Book" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

const Brand = () => (
  <Link to="/" className="flex items-center gap-3" data-testid="nav-home-link" aria-label="Deaf Education Consulting LLC, home">
    <LogoMark size={56} className="shrink-0 rounded-full shadow-sm" title="" />
    <span className="font-display text-lg leading-tight" aria-hidden="true">Deaf Education <em>Consulting</em> LLC</span>
  </Link>
);

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="bg-cream text-ink relative z-20">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 bg-teal text-paper px-4 py-2 rounded-full font-sans" data-testid="skip-link">
        Skip to main content
      </a>
      <nav aria-label="Main" className="max-w-6xl mx-auto px-6 py-6 flex items-center justify-between gap-4">
        <Brand />
        <ul className="hidden xl:flex items-center gap-7 font-sans text-[15px]">
          {LINKS.map((l) => (
            <li key={l.to}>
              <NavLink to={l.to} className="link-u py-1" data-testid={`nav-${l.label.toLowerCase()}-link`}>{l.label}</NavLink>
            </li>
          ))}
          <li>
            <Link to="/contact#consultation" className="whitespace-nowrap bg-teal text-paper rounded-full px-5 py-2.5 hover:bg-teal-deep transition-colors" data-testid="nav-consultation-cta">
              Request a consultation
            </Link>
          </li>
        </ul>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="xl:hidden p-2 rounded-full border border-ink/30" aria-label="Open menu" data-testid="mobile-menu-button">
              <Menu className="w-5 h-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="bg-cream text-ink w-[85vw] max-w-sm [&>button]:hidden">
            <div className="flex items-center justify-between">
              <SheetTitle className="font-display text-xl font-normal">Menu</SheetTitle>
              <SheetClose className="p-2 rounded-full border border-ink/30" aria-label="Close menu" data-testid="mobile-menu-close">
                <X className="w-5 h-5" />
              </SheetClose>
            </div>
            <ul className="mt-10 space-y-5 font-display text-2xl">
              <li><NavLink to="/" end onClick={() => setOpen(false)} data-testid="mobile-nav-home">Home</NavLink></li>
              {LINKS.map((l) => (
                <li key={l.to}>
                  <NavLink to={l.to} onClick={() => setOpen(false)} data-testid={`mobile-nav-${l.label.toLowerCase()}`}>{l.label}</NavLink>
                </li>
              ))}
            </ul>
            <Link to="/contact#consultation" onClick={() => setOpen(false)} className="mt-10 inline-flex bg-teal text-paper rounded-full px-6 py-3 font-sans" data-testid="mobile-nav-consultation-cta">
              Request a consultation
            </Link>
          </SheetContent>
        </Sheet>
      </nav>
    </header>
  );
};
